import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=ae91f2fc&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/home/noticeDetail.css?vue&type=style&index=0&id=ae91f2fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae91f2fc",
  null
  
)

export default component.exports